import React, { useEffect } from "react";
import { useSearchParams, Navigate } from "react-router-dom";

/**
 * /join?ref=YBMABC12 — referral attribution entry point.
 * Captures the referral code into sessionStorage so attorney signup can attach it
 * even if the attorney doesn't immediately register. First-touch, permanent.
 */
export default function JoinRedirectPage() {
    const [search] = useSearchParams();
    const ref = (search.get("ref") || "").trim().toUpperCase();

    useEffect(() => {
        if (ref) {
            try { sessionStorage.setItem("ll_ref", ref); } catch { /* ignore */ }
        }
    }, [ref]);

    // Land on attorney registration with the code pre-loaded.
    return <Navigate to={`/attorney/auth?mode=register${ref ? `&ref=${ref}` : ""}`} replace />;
}
